import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const PERSON_ITEM_CLASS_NAME = 'PersonListItem';
export const PERSON_ITEM_CLASS_SLOTS: Array<keyof PersonListItemClasses> = [
	'root',
] as const;

export type PersonListItemClassSlot = (typeof PERSON_ITEM_CLASS_SLOTS)[number];

export interface PersonListItemClasses {
	root: string;
	isActive: string;
}

export type PersonListItemClassKey = keyof PersonListItemClasses;

export const getPersonListItemUtilityClass = (slot: string) =>
	generateUtilityClass(PERSON_ITEM_CLASS_NAME, slot as PersonListItemClassSlot);

export const personListItemClasses: PersonListItemClasses =
	generateUtilityClasses(
		PERSON_ITEM_CLASS_NAME,
		PERSON_ITEM_CLASS_SLOTS.concat(['isActive']),
	);

export default personListItemClasses;
